import {useQuery} from "@tanstack/react-query";
import {axiosClient} from "../utils/axiosClient";
import {Alert, Button} from "@mui/material";
import {InertiaLink} from "@inertiajs/inertia-react";

export default function EmailValidation({ values }) {
    const { data: validationResponse, isFetched } = useQuery({
        queryKey: ["order.validateEmail", values.email, values.country_id],
        queryFn: async () => {
           return axiosClient.post(route("order.validateEmail"), { key: "email", value: values.email, country_id: values.country_id })
               ?.then(response => response.data);
        },
    });

    if(isFetched && !!validationResponse?.messageInAlert) {
        return <Alert severity={"warning"} action={
            <div className={"mt-2"}>
                <Button className={"mt-2"} component={InertiaLink} href={route("register")} variant={"contained"} color={'secondary'} size="small">
                    Register
                </Button>
            </div>
        }>
            <span dangerouslySetInnerHTML={{__html: validationResponse?.messageInAlert}}></span>
        </Alert>;
    }

    return <div></div>;
}
